import { render, staticRenderFns } from "./organs-list.vue?vue&type=template&id=2e443433&"
import script from "./organs-list.vue?vue&type=script&lang=js&"
export * from "./organs-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "organs-list.vue"
export default component.exports